import { Button } from '@design-system';
import { useSelfRecord } from '../hooks/use-self-record';

function formatValue(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

function RecordTable({ title, record }: { title: string; record: Record<string, unknown> | null }) {
  return (
    <div className="rounded-md border border-gray-200 p-4">
      <h3 className="mb-3 font-medium">{title}</h3>
      {record ? (
        <dl className="grid grid-cols-[minmax(0,14rem)_1fr] gap-x-4 gap-y-1 text-sm">
          {Object.entries(record).map(([key, value]) => (
            <div key={key} className="contents">
              <dt className="truncate font-mono text-gray-500">{key}</dt>
              <dd className="break-all font-mono">{formatValue(value)}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <p className="text-sm text-gray-500">No record found.</p>
      )}
    </div>
  );
}

export function UserSelfView() {
  const { user, advisor, isPending, isError, error, refetch, isFetching } = useSelfRecord();

  if (isPending) {
    return <p className="text-sm text-gray-500">Loading your records…</p>;
  }
  if (isError) {
    return (
      <p className="text-sm text-red-600">
        {error instanceof Error ? error.message : 'Failed to load records.'}
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button variant="outline" size="sm" onClick={() => void refetch()} disabled={isFetching}>
          {isFetching ? 'Refreshing…' : 'Refresh'}
        </Button>
      </div>
      <RecordTable title="Users record" record={user} />
      <RecordTable title="Advisors record" record={advisor} />
    </div>
  );
}
